import { useScreenWidth } from "@/hooks/useWindowSize";
import { ScreenSize } from "@/constants";

export const useIsMobileView = () => {
  const { breakpoint } = useScreenWidth();
  return breakpoint === ScreenSize.xs;
};
